/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class ChangeVisTypeActionAPI
 * @hideconstructor
 * @classdesc Represents the API to change the type of a visualization.
 */

define([], () => {
	class ChangeVisTypeActionAPI {

		/**
		 * @function ChangeVisTypeActionAPI#openDialog
		 * @description Opens VisChangerView
		 * @public
		 *
		 * @return {Promise<VisChangerView>}
		 *
		 */
		openDialog() {}

		/**
		 * @function ChangeVisTypeActionAPI#removeDialog
		 * @description Closes VisChangerView and removes everything from the DOM
		 * @public
		 *
		 */
		removeDialog() {}

		/**
		 *@function ChangeVisTypeActionAPI#setVisType
		 *@description change the current visualization to be the new type
		 *@public
		 *@param {String} contentId, Content ID of the current visualization
		 *@param {String} type, the new visualization type, such as 'Driver Analysis'
		 *@param {Object} transactionToken, passed in transactionToken
		 */
		setVisType() {}
	}
	return ChangeVisTypeActionAPI;
});
